import _ChaunveMap from "./ChaunveMap";
import _WaferMap from "./WaferMap";

const MapTool = {};
MapTool.WaferMap = _WaferMap;
MapTool.ChaunveMap = _ChaunveMap;


export const WaferMap = _WaferMap;
export const ChaunveMap = _ChaunveMap;

export default MapTool;